import React, { useState } from 'react';
import {
  Drawer, DrawerHeader, DrawerBody,
  IconButton,
  Typography
} from '@one-thd/sui-atomic-components';
import { Close } from '@one-thd/sui-icons';
import map from 'lodash/map';
import { trackHowItWorks } from '../../utils/analytics/trackEvents';
import { LinkButton, CircleIcon, SectionWithBuffer } from './styles';
import { howItWorksData } from './constants';

const HowItWorksDrawer = () => {
  const [showDrawer, setShowDrawer] = useState(false);

  const openDrawer = () => {
    setShowDrawer(true);
    trackHowItWorks();
  };
  const closeDrawer = () => setShowDrawer(false);

  return (
    <>
      <LinkButton onClick={openDrawer}>
        <Typography paragraph decoration="underline">How It Works</Typography>
      </LinkButton>
      <Drawer data-testid="my__drawer" open={showDrawer} position="right" onClose={closeDrawer}>
        <DrawerHeader
          startAdornment={(<Typography variant="h4">How it Works</Typography>)}
          endAdornment={(
            <IconButton
              aria-label="Close How It Works Drawer"
              data-testid="how-it-works-close"
              icon={Close}
              onClick={closeDrawer}
            />
          )}
        />
        <DrawerBody>
          {map(howItWorksData, ({ id, title, text }) => (
            <SectionWithBuffer key={id}>
              <CircleIcon id={id} />
              <Typography variant="h5">{title}</Typography>
              <Typography paragraph>{text}</Typography>
            </SectionWithBuffer>
          ))}
        </DrawerBody>
      </Drawer>
    </>
  );
};

export default HowItWorksDrawer;
